// import {GetListParams, InputProps, useDataProvider, useGetList, useInput} from 'ra-core';
import HelperText from './shared/HelperText';
import Label from 'components/basic/Label';
import {AutocompleteProps} from 'components/basic/Autocomplete';
import {ReactNode, useMemo, useState} from 'react';
import clsx from 'clsx';
import {ChoiceProps} from 'hooks/types';
import {InputProps} from '@/hooks/useInput';
import {BaseRecord, CrudFilters, useList, UseListProps} from '@refinedev/core';
import {useFieldArray} from 'react-hook-form';
import Autocomplete2 from '../basic/Autocomplete2';
import _ from 'lodash';

export type AutocompleteArrayInputProps = InputProps & {
  reference: string;
  refetchFullValue?: boolean;
  autoCompleteProps?: Partial<AutocompleteProps>;
  renderSelectedItemsFirst?: boolean;
  renderSelectedItems?: (items: ChoiceProps[], removeAt: (Number) => void) => ReactNode;
  // build filter from text input
  buildFilter?: (text: string) => CrudFilters;
  // filter available choices from referenced data
  // availableChoicesFilter?: (item: ChoiceProps) => boolean;
} & React.ComponentProps<'div'> &
  Partial<UseListProps<BaseRecord, unknown, BaseRecord>>;

const AutocompleteArrayInput = (props: AutocompleteArrayInputProps) => {
  const {
    reference,
    className,
    autoCompleteProps,
    renderSelectedItemsFirst,
    renderSelectedItems,
    pagination = {current: 0, pageSize: 30},
    sorters = [{field: 'id', order: 'asc'}],
    filters: initialFilter = [],
    meta,
    buildFilter = (text: string) => [
      {
        field: '_search',
        operator: 'contains',
        value: text,
      },
    ], //default filter
    refetchFullValue,
    label,
    hidden,
    source,
    placeholder,
    // availableChoicesFilter = item => true,
    ...rest
  } = props;

  // const dataProvider = useDataProvider()();

  const {fields, ...fieldArrayActions} = useFieldArray({
    name: source,
    keyName: 'uid' as 'id',
    ...rest,
  });

  const {append, remove} = fieldArrayActions;

  const [filters, setFilters] = useState<any>(initialFilter);

  const {data, isFetching} = useList({
    resource: reference,
    sorters,
    filters,
    pagination,
    meta,
  });

  const availableChoices = useMemo(() => {
    return data?.data || []; //.filter(availableChoicesFilter);
  }, [data]);

  function addItem(choice: ChoiceProps) {
    // if exists, skip
    if (fields.find(c => c.id === choice.id)) return;
    // listActions.push(choice);
    append(choice);
  }

  const onSearch = useMemo(
    () =>
      _.debounce((text: string) => {
        setFilters(buildFilter(text));
      }, 300),
    [buildFilter],
  );

  if (hidden) return null;

  return (
    <div className={clsx('form-control w-full', className)}>
      <Label>{label}</Label>

      <div className={clsx('relative')} {...rest}>
        {renderSelectedItemsFirst && renderSelectedItems?.(fields, remove)}
        {/* auto complete input */}
        <Autocomplete2
          placeholder={placeholder}
          choices={availableChoices || []}
          onInputChange={onSearch}
          getOptionValue={v => v} //value is item itself
          isLoading={isFetching}
          // isMore={pageInfo?.hasNextPage}
          onSelect={choice => {
            if (choice) addItem(choice);
            onSearch(''); //clear search
          }} //when autocomplete select item
          clearSearchOnSelect={true}
          {...autoCompleteProps}
        />

        {!renderSelectedItemsFirst && renderSelectedItems?.(fields, remove)}
      </div>
      <HelperText helperText={props.helperText} />
      {/* <ErrorText {...fieldState} /> */}
    </div>
  );
};

export default AutocompleteArrayInput;
